import { forwardRef, type Ref, type SVGProps } from "react";
const IconCafeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M6 8.236C6.02 18.865 7 25 12 25h6c3.219 0 4.763-2.487 5.465-7.037 1.182-.095 2.24-.395 3.05-1.07C27.585 16.003 28 14.653 28 13c0-.888-.186-1.648-.576-2.267-.393-.626-.944-1.026-1.53-1.277-.594-.255-1.261-.367-1.897-.417L24 8.236C24.002 7 23.106 6 22.001 6H8C6.894 6 5.998 7.001 6 8.236m4.32 14.176c.388.362.883.588 1.68.588h6c.817 0 1.319-.23 1.706-.59.44-.409.89-1.137 1.268-2.385.769-2.543 1.016-6.453 1.026-11.793A.4.4 0 0 0 21.934 8H8.066A.4.4 0 0 0 8 8.232c.01 5.334.27 9.246 1.046 11.789.38 1.25.833 1.98 1.274 2.391m14.915-7.055c-.32.267-.802.466-1.521.568.138-1.466.216-3.097.255-4.881.433.039.816.112 1.137.25.289.124.488.286.626.504.141.225.268.59.268 1.202 0 1.347-.334 1.998-.765 2.357"
      clipRule="evenodd"
    />
    <path d="M7 26a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2z" />
  </svg>
);
const ForwardRef = forwardRef(IconCafeOutlineSVG);
ForwardRef.displayName = "IconCafeOutline";
export { ForwardRef as IconCafeOutline };
